import api from "./api";

export const getTimesheets = async (
  year,
  userId,
  monthId,
  userTypeId,
  projectTypeId,
  periodTypeId,
  page,
  rowCount
) => {
  try {
    let url = `Timesheets?userTypeId=${userTypeId}&userId=${userId}&month=${monthId}&periodTypeId=${periodTypeId}&projectTypeId=${projectTypeId}&year=${year}&pageNumber=${page}&pageSize=${rowCount}`;
    const response = await api.get(url);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteTimeSheetDetails = async (loggedInUserTypeId, id) => {
  try {
    const response = await api.delete(
      `/Timesheets/${id}?loggedInUserTypeId=${loggedInUserTypeId}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const updateTimesheet = async (timesheetData) => {
  try {
    const response = await api.put("/Timesheets", timesheetData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeeList = async (managerId) => {
  try {
    const response = await api.get(`/Users/${managerId}/employees`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getTimesheetSummary = async (
  year,
  month,
  projectType,
  userId,
  status
) => {
  try {
    
    const response = await api.get(
      `/Users/TimesheetReport?year=${year}&month=${month}&projectTypeId=${projectType}&statusId=${status}&userId=${userId}`
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getTimesheetSummaryExcelFile = async(  year,
  month,
  loggedInUserId,
  userTypeId,
  projectType,
  userId,
  status,name)=>{
    let response;
  try {
    //TODO:include &userId=${employeeId}
   response = await api.get(
      `/Timesheets/import/timesheetSummary?year=${year}&month=${month}&loggedInUserId=${loggedInUserId}&userTypeId=${userTypeId}&projectTypeId=${projectType}&employeeId=${userId}&statusId=${ status}`,
      {
        responseType: "blob",
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }
    );

    // Extract filename from the Content-Disposition header
    const disposition = response?.headers["content-disposition"];
    let filename = `Timesheets_${year}_${name}.xlsx`; // Default filename if not found

    if (disposition && disposition?.includes("filename=")) {
      const match = disposition?.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    // Create a Blob URL for the Excel file
    const blob = new Blob([response?.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    return { url, filename ,response}; // Return both the URL and the filename
  } catch (error) {
    throw response || error;
  }
}

export const sendEmailNotification = async (
  year,
  month,
  loggedInroleId,
  userIds
) => {
  try {
    const requestBody ={
      userId:userIds,
      year:year,
      month:month,
      loggedInUserTypeId:loggedInroleId
    }
    const response = await api.post( 
      `/Emails/Send`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getAllEmployeeList = async () => {
  try {
    const response = await api.get(`/Users`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getTimesheetById = async (id) => {
  try {
    const response = await api.get(`/Timesheets/${id}`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getTimesheetDocumentById = async (id) => {
  try {
    const response = await api.get(`/Timesheets/${id}/download`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
